import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hero from "./components/Hero";
import LiveResults from "./components/LiveResults";
import Bonuses from "./components/Bonuses";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

const Home = () => (
  <div className="relative min-h-screen bg-[#050b1f] text-white overflow-hidden">
    {/* radial glows */}
    <div className="pointer-events-none fixed inset-0 z-0">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[500px] w-[900px] rounded-full bg-blue-600/20 blur-[120px]" />
      <div className="absolute top-[40%] -left-40 h-[400px] w-[400px] rounded-full bg-indigo-700/15 blur-[100px]" />
      <div className="absolute top-[70%] -right-40 h-[400px] w-[400px] rounded-full bg-sky-600/15 blur-[100px]" />
    </div>
    <div className="relative z-10">
      <Hero />
      <LiveResults />
      <HowItWorks />
      <Bonuses />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
